import { isPlatformBrowser, PlatformLocation, Location } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute, Data } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Constant } from './constants/constant';
import { AnalyticService } from './services/analytic-service';
import { ServiceWorkerService } from './services/service-worker.service';
import { UrlService } from './services/url-service.service';
import { DOCUMENT } from '@angular/common';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { PushmsgService } from 'src/app/services/pushmsg.service';
import { ShareChatTrackingService } from './services/share-chat-tracking.service';
import { NewsletterPopupService } from './services/newsletter-popup.service';
import { WssService } from 'src/app/services/wss.service';
import { ScreenRecordingService } from './services/screen-recording.service';
import { CountryLocationService } from './services/country-location.service';
import { ConfigServiceService } from './services/config-service.service';
// import { FirebaseMessagingService } from 'src/app/services/firebase-messaging.service';
import { CommonService } from './services/common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  private _touchLogger: any;
  private _iosTouchStart: any;
  private _iosTouchEnd: any;
  private _lastSyntheticClick = 0;
  //@ViewChild('dialogRef')
  public serverPath = environment.commonImageApi + "logo/logo.png";
  public serverPath4 = environment.commonImageApi + "favImage/fav.png";
  private routerSubscription: Subscription;
  //dialogRef!: TemplateRef<any>;
  @ViewChild('dialogRef') dialogRef: TemplateRef<any>;

  newUrl: any;
  url: any;
  url1: any;
  subscription: any;
  browserRefresh: boolean;
  refresh: boolean;
  previousUrl: string = null;
  currentUrl: string = null;
  //pushPayload: INotificationPayload;
  hasPermission: any;
  token: any;
  data: any;

  showPopup = false;
  showBackToTop: boolean = false;
  countryCode: any;
  configData: any;

  constructor(
    public router: Router,
    private location: Location,
    public platform1: PlatformLocation,
    private urlService: UrlService,
    private swUpdate: ServiceWorkerService,
    private analyticService: AnalyticService,
    private title: Title,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    public dialog: MatDialog,
    private push_msg: PushmsgService,
    private _activatedRoute: ActivatedRoute,
    private shareChatTrackingService: ShareChatTrackingService,
    private newsletterPopupService: NewsletterPopupService,
    private cdr: ChangeDetectorRef,
    private wss: WssService,
    public screenRecordDetectionService: ScreenRecordingService,
    private countryLocationService: CountryLocationService,
    private configService: ConfigServiceService,
    private titleService: Title,
    private commonService: CommonService
  ) {
    this.swUpdate.checkForUpdates();

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.newUrl = event.url;
      });

    this.newUrl = this.router.url;


  }

  getUserLocationData() {



    this.countryCode = this.countryLocationService.getCountryCode()
  }


  ngOnInit(): void {
   

    let countryData = localStorage.getItem(Constant.COUNTRY_LOCATION);

    if (countryData == null || countryData == undefined) {
      this.getUserLocationData();
    }


    this.newsletterPopupService.getPopupVisibility().subscribe((isVisible) => {
      this.showPopup = isVisible;
    });

    //this.screenRecordDetectionService.detectScreenRecording();

    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.previousUrl = this.currentUrl;
      this.currentUrl = event.url;
      this.urlService.setPreviousUrl(this.previousUrl);
      if (this.currentUrl.includes("/pr?sid=")) {

        let url = this.currentUrl.split("sid=")[1];

        this.urlService.setBreadCrumpId(url);
      }

      if (this.previousUrl == "/orders" && this.currentUrl == "/checkout") {
        this.router.navigate(['/']);
      }

      if (localStorage.getItem(Constant.GOOGLE_ANALYTICS_ENABLED) != undefined && localStorage.getItem(Constant.GOOGLE_ANALYTICS_ENABLED) != '') {
        this.analyticService.pageView(event.url, this.title.getTitle())
      }

      if (localStorage.getItem('shareChat') != undefined && localStorage.getItem('shareChat') != '') {

        this.shareChatTrackingService.initializeTracking
          (localStorage.getItem('shareChat'));
      }


    });
    this.startStopTimer();
   // this.wss.connectWithSocketIOServer();

    
    // this.enableNotifications();
    // this.messagingService.requestPermission();
    // this.messagingService.listen();
    // this.messagingService.currentMessage.subscribe(msg => {
    //   this.message = msg;
    // });

  }

  message: any;
  author: any;
  enableNotifications() {
    // Firebase messaging service worker registration removed; using Angular
    // Service Worker (ngsw) for caching and handling notifications if configured.
  }


  getConfigData() {
    let data = this.configData;

    this.author = data?.author;

    if (this.author !== undefined) {
      this.titleService.setTitle(this.author);
    }


  }

  @HostListener('window:scroll', ['$event'])
  onScrollEvent($event: Event): void {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const box = document.getElementById('box');

    if (box) {
      if (scrollTop >= 200) {
        box.classList.add("header-fixed");
      } else {
        box.classList.remove("header-fixed");
      }
    }

    this.showBackToTop = scrollTop > 300;
    this.cdr.detectChanges(); // Ensures Angular detects the change and updates the view
  }



  ngAfterViewInit() {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.startStopTimer();
        if (isPlatformBrowser(this.platformId)) {
          //  window.scrollTo(0,0);
        }
      }
    })

    // const script = document.createElement('script');
    // script.src = 'https://www.gstatic.com/dialogflow-console/fast/messenger/bootstrap.js?v=1';
    // script.async = true;
    // script.defer = true;
    // script.onload = () => {
    // };
    // document.body.appendChild(script);

    // this.appendDfMessenger();

  // Debug helper: log touchstart targets to help find elements that may be intercepting taps on iOS
    try {
      if (isPlatformBrowser(this.platformId)) {
        this._touchLogger = (e: TouchEvent) => {
          try {
            // Log target and (if available) composedPath for shadow DOM clarity
            const p = (e as any).composedPath ? (e as any).composedPath() : null;
            // eslint-disable-next-line no-console
            console.log('[touch-debug] touchstart target:', e.target, 'path:', p);
          } catch (err) {
            // ignore
          }
        };
        window.addEventListener('touchstart', this._touchLogger, { passive: true });
      }
    } catch (err) {
      // ignore in non-browser environments
    }

    // Install conservative iOS forwarder (synthesizes clicks for short taps on non-interactive elements)
    try {
      if (isPlatformBrowser(this.platformId) && this.isIosLike()) {
        this.installIosTouchClickForwarder();
      }
    } catch (err) {
      // ignore
    }
  }


  appendDfMessenger() {
    // Create the <df-messenger> element
    const dfMessenger = document.createElement('df-messenger');

    // Set attributes
    dfMessenger.setAttribute('intent', 'WELCOME');
    dfMessenger.setAttribute('chat-title', 'dev-calsoft');
    dfMessenger.setAttribute('agent-id', 'cc0e330c-8185-4e82-b1bc-c51e1dd95577');
    dfMessenger.setAttribute('language-code', 'en');

    // Append the element to the body of the document
    document.body.appendChild(dfMessenger);
  }

  private timeoutId: any;

  startStopTimer() {
    // Clear previous timeout (if any)
    clearTimeout(this.timeoutId);

    // Start a new timeout for 5 minutes
    this.timeoutId = setTimeout(() => {
      window.stop();
    }, 45000);
  }




  @HostListener('window:popstate') backbuttonpressed() {
    const currentUrl = this.router.url;
    if (currentUrl === "/home" && navigator['app']) {
      navigator['app'].exitApp();
    }
  }



  ngOnDestroy() {
    // Unsubscribe from the router events and clear the timeout
    this.routerSubscription.unsubscribe();
    clearTimeout(this.timeoutId);
    try {
      if (this._touchLogger) {
        window.removeEventListener('touchstart', this._touchLogger as any);
        this._touchLogger = null;
      }
    } catch (err) {
      // ignore
    }
    // cleanup ios forwarder
    try {
      if (this._iosTouchStart) {
        window.removeEventListener('touchstart', this._iosTouchStart as any);
        this._iosTouchStart = null;
      }
      if (this._iosTouchEnd) {
        window.removeEventListener('touchend', this._iosTouchEnd as any);
        this._iosTouchEnd = null;
      }
    } catch (err) {
      // ignore
    }
  }

  private isIosLike(): boolean {
    try {
      if (typeof navigator === 'undefined') return false;
      const ua = navigator.userAgent || navigator.vendor || '';
      // iOS devices include iPhone/iPad/iPod; Chrome on iOS still runs WebKit but platform shows iPhone/iPad
      return /iP(ad|hone|od)/.test(ua) || /Macintosh/.test(ua) && 'ontouchend' in document;
    } catch (err) {
      return false;
    }
  }

  private installIosTouchClickForwarder() {
    // conservative heuristics to avoid interfering with scrolling and interactive controls
    let touchStartInfo: { x: number; y: number; t: number; target: EventTarget } | null = null;

    const isInteractive = (el: Element | null) => {
      if (!el) return false;
      const tag = el.tagName.toLowerCase();
      if (['a', 'button', 'input', 'textarea', 'select', 'label'].includes(tag)) return true;
      if (el.hasAttribute && (el.hasAttribute('role') && el.getAttribute('role') === 'button')) return true;
      if (el.getAttribute && el.getAttribute('onclick')) return true;
      if ((el as HTMLElement).tabIndex && (el as HTMLElement).tabIndex >= 0) return true;
      return false;
    };

    this._iosTouchStart = (ev: TouchEvent) => {
      try {
        const touch = ev.changedTouches && ev.changedTouches[0];
        if (!touch) return;
        touchStartInfo = { x: touch.clientX, y: touch.clientY, t: Date.now(), target: ev.target };
      } catch (err) {
        touchStartInfo = null;
      }
    };

    this._iosTouchEnd = (ev: TouchEvent) => {
      try {
        const touch = ev.changedTouches && ev.changedTouches[0];
        if (!touch || !touchStartInfo) return;
        const dx = Math.abs(touch.clientX - touchStartInfo.x);
        const dy = Math.abs(touch.clientY - touchStartInfo.y);
        const dt = Date.now() - touchStartInfo.t;
        // small movement and reasonably short tap
        if (dx <= 10 && dy <= 10 && dt < 700) {
          // get the topmost element at the touch point
          const el = document.elementFromPoint(touch.clientX, touch.clientY) as Element | null;
          if (!el) return;
          // don't synthesize for interactive elements (to avoid double clicks)
          if (isInteractive(el) || el.closest && el.closest('a, button, input, textarea, select, label, [role="button"], [tabindex]')) {
            return;
          }

          // Avoid generating synthetic clicks too close together
          const now = Date.now();
          if (now - this._lastSyntheticClick < 300) return;
          this._lastSyntheticClick = now;

          const evt = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
          // Dispatch on the topmost element
          (el as Element).dispatchEvent(evt);
        }
      } catch (err) {
        // ignore
      } finally {
        touchStartInfo = null;
      }
    };

    // use passive listeners to avoid blocking scroll
    window.addEventListener('touchstart', this._iosTouchStart as any, { passive: true });
    window.addEventListener('touchend', this._iosTouchEnd as any, { passive: true });
  }

  openTempDialog(payload) {
    console.log(JSON.stringify(payload));
    //alert('Notification: '+ payload.title + ' --- '+ payload.body)

    const mydata = this.dialog.open(this.dialogRef, { data: payload });
    mydata.afterClosed().subscribe((res) => {

      // Data back from dialog
      console.log({ res });
    });

  }


  @HostListener('document:contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    if (this.newUrl.includes('/course-detail/')) {
      event.preventDefault();
    }
  }


  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.newUrl.includes('/course-detail/')) {
      if (
        event.key === 'F12' ||
        (event.ctrlKey && event.shiftKey && event.key === 'I') ||
        (event.ctrlKey && event.key === 'u') ||
        (event.metaKey && event.altKey && event.key === 'r') ||
        event.key === 'PrintScreen' // Block Print Screen key
      ) {
        event.preventDefault();
      }
    }
  }

}
